import React, { useContext } from "react";
import { TextContainer } from "../components/textContainer";
import { PageContainer } from "../components/pageContainer";
import { TextInput } from "../components/textInput";
import { Nav } from "../components/nav";
import { F1Context } from "../context";
import { SaveButton } from "../components/saveButton";

export const BoldPredictionsPage = () => {
  const [context, updateContext] = useContext(F1Context);
  return (
    <PageContainer>
      <div style={{ width: "340px", textAlign: "left", marginBottom: "10px" }}>
        Bold Predictions
      </div>
      <TextContainer>
        As a group, create one or more bold prediction categories
      </TextContainer>
      <TextInput
        value={context.boldPredictions}
        onChange={(e) => {
          updateContext({
            type: "update-bold-predictions",
            boldPredictions: e.target.value,
          });
        }}
      />
      <SaveButton />
      <Nav />
    </PageContainer>
  );
};
